<div [class.extra-small]="extraSmall" class="ac-toggle-container">
    <mat-slide-toggle [(ngModel)]="acModel" #matSlideToggle
                      (ngModelChange)="onChange($event)"
                      [disabled]="(ngDisabled || (acInputContainer && acInputContainer.isDisabled))?true:null"
                      color="primary"
                      [id]="toggleId">
        {{text}}
    </mat-slide-toggle>
</div>
